import { useNavigate, useLocation, Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/lib/data";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (link) => {
    if (link.to) return navigate(link.to);
    if (location.pathname !== "/") return navigate("/" + link.href);
    document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="relative bg-[#0A0607] border-t border-[#D4AF37]/20 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-16">
          <div className="max-w-sm">
            <img src="/logo.png" alt="Palace of Flavor" className="h-20 w-auto mb-5" />
            <p className="font-body text-[#A89F91] leading-relaxed">
              Authentic Indian cuisine and royal catering, proudly serving {CONTACT.area}.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="w-11 h-11 flex items-center justify-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A0607] transition-colors duration-300">
                <Facebook size={18} />
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-11 h-11 flex items-center justify-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A0607] transition-colors duration-300">
                <Instagram size={18} />
              </a>
            </div>
          </div>
          <div className="flex gap-16">
            <div>
              <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Explore</h4>
              <ul className="space-y-3">
                {NAV_LINKS.map((l) => (
                  <li key={l.label}>
                    <button data-testid={`footer-nav-${l.label.toLowerCase()}`} onClick={() => go(l)} className="font-body text-[#A89F91] hover:text-[#FDFBF7] transition-colors">{l.label}</button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Contact</h4>
              <ul className="space-y-3 font-body text-[#A89F91]">
                <li><a href={CONTACT.phoneHref} className="hover:text-[#FDFBF7] transition-colors">{CONTACT.phone}</a></li>
                <li><a href={CONTACT.emailHref} className="hover:text-[#FDFBF7] transition-colors break-all">{CONTACT.email}</a></li>
                <li>{CONTACT.area}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none px-4">
        <h2 className="font-display text-center leading-none gold-gradient-text opacity-90 text-[15vw] font-medium tracking-tight">
          PALACE OF FLAVOR
        </h2>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-8 border-t border-[#D4AF37]/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="font-body text-xs text-[#A89F91]">© {new Date().getFullYear()} Palace of Flavor · Authentic Indian Cuisine</p>
        <div className="flex items-center gap-4">
          <p className="font-body text-xs text-[#A89F91]">Crafted with spice & soul in Tampa</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-body text-xs text-[#A89F91]/50 hover:text-[#D4AF37] transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
